import { InjectionToken } from '@angular/core';
import { LocalCache } from '@nk/caching-lib';
import {
  CompanyFlagCompositeEntity,
  CompanyFlagDashboardCompanyComposite,
  CompanyFlagHistoryCompositeEntity,
  CompanyFlagTypeAggregateComposite,
  CompanyFlagTypeEntity,
  SimpleCollection,
  WithUuid,
} from '@nk/data-entities-lib';
import { Dict } from '@nk/utils-lib';
import { Observable } from 'rxjs';

export interface CompanyFlagApiService {
  companyFlagHistoryCompositeByCompanyCache: LocalCache<
    CompanyFlagApiService,
    (companyUuid: string) => Observable<CompanyFlagHistoryCompositeEntity[]>
  >;
  companyFlagTypeListCache: LocalCache<CompanyFlagApiService, () => Observable<WithUuid<CompanyFlagTypeEntity>[]>>;
  legalCompanyFlagList(): Observable<Dict<WithUuid<CompanyFlagTypeEntity>>>;
  companyFlagCompositeByCompanyCache: LocalCache<
    CompanyFlagApiService,
    (
      companyUuid: string,
      lookbackDays?: number,
      lookbackDate?: string,
      noContextFlag?: boolean,
      companyFlagTypeIdentifiers?: string[],
    ) => Observable<CompanyFlagCompositeEntity[]>
  >;
  companyFlagDashboardCompanyCompositeCollectionCache: LocalCache<
    CompanyFlagApiService,
    (
      watchlistUuids: string[],
      companyFlagCategoryKeys: string[],
      companyFlagTypeUuids: string[],
      ignoreCompanyFlagTypeUuids: string[],
      timeHorizon: 'weeks' | 'days' | 'months',
      timeHorizonValue: number,
      limit: number,
      offset: number,
    ) => Observable<SimpleCollection<CompanyFlagDashboardCompanyComposite>>
  >;
  companyFlagTypeAggregateCompositeCache: LocalCache<
    CompanyFlagApiService,
    (
      watchlistUuids: string[],
      companyFlagCategoryKeys: string[],
      ignoreCompanyFlagTypeUuids: string[],
      timeHorizon: 'weeks' | 'days' | 'months',
      timeHorizonValue: number,
    ) => Observable<CompanyFlagTypeAggregateComposite[]>
  >;
}
export const COMPANY_FLAG_API_SERVICE_TOKEN = new InjectionToken<CompanyFlagApiService>('CompanyFlagApiService');
